export const formFields = {
  1: {
    name: 'name',
    label: 'Name',
    type: 'text',
    placeholder: 'Name',
  },
  2: {
    name: 'phoneNumber',
    label: 'Phone Number',
    type: 'tel',
    defaultCountry: 'US',
    placeholder: 'Enter your phone number',
  },
  3: [
    {
      name: 'bestDay',
      label: 'Best day of week to call (optional)',
      options: [
        {
          label: 'Monday',
          value: 'monday',
        },
        {
          label: 'Tuesday',
          value: 'tuesday',
        },
        {
          label: 'Wednesday',
          value: 'wednesday',
        },
        {
          label: 'Thursday',
          value: 'thursday',
        },
        {
          label: 'Friday',
          value: 'friday',
        },
      ],
      placeholder: 'Select day of week',
      type: 'dropdown',
    },
    {
      name: 'bestTime',
      label: 'Best time of day to call (optional)',
      options: [
        {
          label: 'Morning',
          value: 'morning',
        },
        {
          label: 'Afternoon',
          value: 'afternoon',
        },
      ],
      placeholder: 'Select time of day',
      type: 'dropdown',
    },
  ],
};
